import { HeaderBehavior } from "@components/layout/DefaultPageLayout";
import { useExperiment } from "@statsig/react-bindings";
import { useRouter } from "next/router";

import { DONATE_HASH } from "@every.org/common/src/helpers/clientRoutes";

import { useEdoRouter } from "src/hooks/useEdoRouter";

export function useHeaderBehaviorOnLargeScreens(): HeaderBehavior {
  const { query } = useRouter();
  const { hash } = useEdoRouter();

  const isLargeScreen = query?.viewport !== "mobile";

  const openDonatePage =
    hash.includes(DONATE_HASH) || hash.includes(DONATE_HASH.substring(1));

  const disableExposureLog = !isLargeScreen || openDonatePage;

  const ABTestGroup = useExperiment("disappearing_header", {
    disableExposureLog,
  }).groupName;

  switch (ABTestGroup) {
    case "Hide":
      return HeaderBehavior.HIDE;
    case "Static":
      return HeaderBehavior.STATIC;
    default:
      return HeaderBehavior.FIXED;
  }
}
